import { Injector, Provider } from '@angular/core';
import { CLOUD_MESSAGING } from '../tokens/cloud-messaging.token';
import { WebCloudMessagingService } from '@app/services/web-cloud-messaging-service';
import { CapacitorCloudMessagingService } from '@app/services';
import { CloudMessagingProvider } from '../models';
import { isFromMobileApp } from '../helpers';

export function cloudMessagingProviderFactory(
  injector: Injector,
): CloudMessagingProvider {
  return isFromMobileApp()
    ? injector.get(CapacitorCloudMessagingService)
    : injector.get(WebCloudMessagingService);
}

export const CLOUD_MESSAGING_PROVIDER: Provider = {
  provide: CLOUD_MESSAGING,
  useFactory: cloudMessagingProviderFactory,
  deps: [Injector],
};
